<template>
  <div class="row match-height">
    <UserInfo />
    <ChangePassword />
  </div>
</template>

<script>
import UserInfo from "./UserInfo.vue";
import ChangePassword from "./ChangePassword.vue";

export default {
  components: {
    UserInfo,
    ChangePassword,
  },
};
</script>
